import * as tslib_1 from "tslib";
import objectKeysToLowerCase from "./objectKeysToLowerCase";
// usage:
//               [variable] [directive] [directive parameter]
// interpolate('<h1>{title | transform | uppercase}</h1>',
//             { title: 'page title' },
//             {
//                  transform: (source, transformation) => {
//                      switch (transformation) {
//                          case 'uppercase': return source.toUpperCase();
//                          case 'lowercase': return source.toLowerCase();
//                          case 'invert': return source.split('').map(char => char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase());
//                          default: return source;
//                      }
//                  }
//             })
//
function interpolate(template, replacements, directives) {
    return (template || "").replace(/\{([\w\d_]+(?:\s*\|[^}]+)*)\}/g, function (match, expression) {
        replacements = objectKeysToLowerCase(replacements);
        var variable = expression.split('|'), variableName = variable[0].trim().toLowerCase();
        var value = replacements[variableName];
        if (typeof (value) === 'function')
            value = value();
        directives = tslib_1.__assign({}, interpolate.directives, directives);
        var directive = variable.length >= 2 && directives[variable[1].trim()];
        if (directive) {
            var params = variable.slice(2).map(function (param) { return param.trim(); });
            value = directive.apply(variableName, [value].concat(params));
        }
        return value == null ? '' : value;
    });
}
interpolate.directives = {
    uppercase: function (source) { return source ? source.toUpperCase() : source; },
    lowercase: function (source) { return source ? source.toLowerCase() : source; },
    escape: function (source) { return source ? encodeURIComponent(source) : source; }
};
export default interpolate;
//# sourceMappingURL=interpolate.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/misc/interpolate.js
// module id = 54
// module chunks = 1